export const data2_1 = [{
    name: 'Days 日数',
    name_code: "Days",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Available Rooms 总房间数量',
    name_code: "Total_Available_Rooms",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Rooms Occupied 总出租房',
    name_code: "Total_Rooms_Occupied",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Occupancy % 出租率%',
    name_code: "Occupancy",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Average Room Rate 平均每天房价',
    name_code: "Average_Room_Rate",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'RevPAR 单房产值',
    name_code: "RevPAR",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Revenue 收入',
    name_code: "Revenue",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Rooms 客房收入',
    name_code: "Rooms",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Food & Beverage 餐饮收入',
    name_code: "Food_Beverage",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Other Operated Departments 其它部门收入',
    name_code: "Other_Operated_Departments",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Revenues 总收入',
    name_code: "Total_Revenues",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Cost of Sales 销售成本',
    name_code: "Cost_of_Sales",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Food & Beverage 餐饮成本',
    name_code: "Food_Beverage",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Other Operated Departments 其它部门成本',
    name_code: "Other_Operated_Departments",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Cost of Sales 总成本',
    name_code: "Total_Cost_of_Sales",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Payroll Expenses 工资福利',
    name_code: "Payroll_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Rooms 客房',
    name_code: "Rooms",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Other Operated Departments 其它部门',
    name_code: "Other_Operated_Departments",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Payroll Expenses 总工资福利',
    name_code: "Total_Payroll_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Provision for O.E. 营运工具預提',
    name_code: "Provision_for_O.E.",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Rooms 客房',
    name_code: "Rooms",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Other Operated Departments 其它部门',
    name_code: "Other_Operated_Departments",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Provision for O.E. 总营运工具預提',
    name_code: "Total_Provision_for_O.E.",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Other Expenses 其它费用',
    name_code: "Other_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Rooms 客房',
    name_code: "Rooms",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Other Operated Departments 其它部门',
    name_code: "Other_Operated_Departments",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Other Expenses 总其它费用',
    name_code: "Total_Other_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Department Cost/Expenses 部门总成本和费用',
    name_code: "Total_Department_Cost/Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Departmental Profit 部门利润',
    name_code: "Departmental_Profit",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Rooms 客房',
    name_code: "Rooms",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Other Operated Departments 其它部门',
    name_code: "Other_Operated_Departments",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Departmental profit 总部门利润',
    name_code: "Total_Departmental_profit",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Undistributed Operating Expenses 未分配部门费用',
    name_code: "Undistributed_Operating_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Payroll Expenses 工资福利',
    name_code: "Payroll_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Administration & General 行政办',
    name_code: "Administration_General",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Human Resources 人力资源部',
    name_code: "Human_Resources",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Sales & Marketing 市场销售部',
    name_code: "Sales_Marketing",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Property Operation & Maintenance 工程部',
    name_code: "Property_Operation_Maintenance",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Payroll Expenses 总工资福利',
    name_code: "Total_Payroll_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Other Expenses 其它费用',
    name_code: "Other_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Administration & General 行政办',
    name_code: "Administration_General",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Human Resources 人力资源部',
    name_code: "Human_Resources",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Sales & Marketing 市场销售部',
    name_code: "Sales_Marketing",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Property Operation & Maintenance 工程部',
    name_code: "Property_Operation_Maintenance",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Energy Costs 能源费用',
    name_code: "Energy_Costs",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Other Expenses 总其它费用',
    name_code: "Total_Other_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Undistributed Operating Expenses 未分配部门费用总计',
    name_code: "Total_Undistributed_Operating_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Income After Undistributed Operating Expenses',
    name_code: "Income_After_Undistributed_Operating_Expenses",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Insurance 保险',
    name_code: "Insurance",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Base Fee 基本管理费',
    name_code: "Base_Fee",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Brand Service Fee 品牌维护费',
    name_code: "Brand_Service_Fee",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Gross Operating Profit/(Loss) 总毛利润/(亏损)',
    name_code: "Gross_Operating_Profit/(Loss)",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Other Deductions 其它扣除',
    name_code: "Other_Deductions",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Incentive Fees 奖励性管理费',
    name_code: "Incentive_Fees",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Reserve for Capital Expenditure 固定资产备用',
    name_code: "Reserve_for_Capital_Expenditure",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Others 其它',
    name_code: "Others",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: 'Total Other Deductions 其它扣除总计',
    name_code: "Total_Other_Deductions",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}, {
    name: "Owner's Profit/(Loss) 业主利润/(亏损)",
    name_code: "Owner's Profit/(Loss) 业主利润/(亏损)",
    month_actual: 0,
    month_actual_percent: 0,
    month_budget: 0,
    month_budget_percent: 0,
    month_last: 0,
    month_last_percent: 0,
    year_actual: 0,
    year_actual_percent: 0,
    year_budget: 0,
    year_budget_percent: 0,
    year_last: 0,
    year_last_percent: 0,
}]


// WEBPACK FOOTER //
// ./src/components/charter/summary/data.js